import { graphql } from "@acto/gql";
import type { UpdateWorkflowInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";
import { useMutation } from "urql";

const UpdateWorkflowMutation = graphql(`
  mutation UpdateWorkflow($id: ID!, $input: UpdateWorkflowInput!) {
    updateWorkflow(id: $id, input: $input) {
      id
      name
      description
      isActive
      repeat
      dueDate
      pauseTill
      fixedResponsibleEmployee {
        id
        name
      }
    }
  }
`);

export function useUpdateWorkflow() {
  const [result, updateWorkflowMutation] = useMutation(UpdateWorkflowMutation);
  const [error, setError] = useState<Error | null>(null);

  const updateWorkflow = useCallback(
    async (id: string, input: UpdateWorkflowInput) => {
      setError(null);

      try {
        const response = await updateWorkflowMutation({ id, input });

        if (response.error) {
          console.error("unable to update workflow", response.error);
          setError(response.error);

          return null;
        }

        return response.data?.updateWorkflow ?? null;
      } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error("Failed to update workflow");

        console.error("unable to update workflow", error);
        setError(error);

        return null;
      }
    },
    [updateWorkflowMutation],
  );

  const reset = useCallback(() => setError(null), []);

  return { updateWorkflow, isPending: result.fetching, error, reset };
}
